import { useQuery, useLazyQuery, gql } from "@apollo/client"
import { SENSOR_DETAIL_FIELDS } from "./fragments/sensorFieldsFragment"

const SENSOR_QUERY = gql`
  query Sensor($id: ID!, $input: SensorDetailInput!) {
    sensor(id: $id) {
      detail(input: $input) {
        ...SensorDetailFields
      }
    }
  }
  ${SENSOR_DETAIL_FIELDS}
`

const sensorTypePolicies = {
  root: {},
  scoped: {
    Sensor: {
      fields: {
        samples: {
          merge(_, next) {
            return next
          }
        }
      }
    },
    SensorQuery: {
      merge(prev, next) {
        return {
          ...(prev || {}),
          ...next
        }
      }
    }
  }
}

const useQuerySensor = (options) => useQuery(SENSOR_QUERY, options)

const useLazyQuerySensor = (options) => useLazyQuery(SENSOR_QUERY, options)

export { useQuerySensor, useLazyQuerySensor, sensorTypePolicies }
